const floorToFixed = (value: number, precision: number) => parseFloat(value.toFixed(precision));

export default floorToFixed;
